import { LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

import variables from "../../../../../../../assets/styles/sass-resources.scss";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 1,
        rows: 2,
        rowsSize: [1, 5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data:
                      "The discrete Fourier transforms depends on the number of sampled points N and the duration of the window. This example corresponds to the DFT of a pure sine at frequency 1 Hz. The  Fourier transform of the continuous signal corresponds to two peaks at 1 and -1 Hz. In the case of the DFT we can observe secondary lobes due to the windowing of the signal. In addition, the frequency resolution depends on the number of points of the signal.",
                    scrollbars: false,
                    styles: {
                      color: variables["text-secondary"],
                    },
                  },
                },
              },
            },
          ],
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "iframe",
                  options: {
                    src: `${config.IFRAMES_REACT_URL}/0305c/`,
                  },
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
